import { z } from 'zod';
import { endpoint, id, LIMITS } from './common';
import { invitation } from './invitations';

// What the app tells a person about: things that happened to them or on boards they run. The server writes these
// when the event happens; people only read them and mark them read.

export const notificationType = z.enum([
    'invitation.accepted',    // someone you invited joined your board
    'invitation.declined',    // someone you invited turned the invitation down
    'member.role_changed',    // your role on a board changed
    'member.removed',         // you were taken off a board
    'board.changed_by_support', // someone who runs the service changed who is on a board you own (at your request, or to put something right)
    'task.completed',         // someone else completed a task on a board you own or edit
]);
export type NotificationType = z.infer<typeof notificationType>;

export const notification = z.object({
    id: z.string(),
    type: notificationType,
    message: z.string(),
    boardId: z.string().optional(),   // the board it is about; the app links to it
    createdAt: z.string(),
    readAt: z.string().optional(),    // absent until read
});
export type Notification = z.infer<typeof notification>;

// What needs the person's attention: the invitations waiting for an answer, and the newest notifications (newest first)
// with how many of all of them are unread (more than are listed, if there are many).
export const getNotifications = endpoint({
    method: 'GET',
    path: '/notifications',
    response: z.object({
        invitations: z.array(invitation),
        notifications: z.array(notification),
        unreadCount: z.number(),
    }),
});

// Marks the named notifications read; with no ids, all of them.
export const markNotificationsRead = endpoint({
    method: 'POST',
    path: '/notifications/read',
    body: z.object({ ids: z.array(id).max(LIMITS.notificationsPerRequest).optional() }),
    response: z.object({ unreadCount: z.number() }),
});
